'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.routerReducer = exports.LOCATION_REPLACE = exports.LOCATION_GO = exports.LOCATION_CHANGE = exports.ConnectedRouter = undefined;

var _reducer = require('./reducer');

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'LOCATION_GO', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_GO;
  }
});
Object.defineProperty(exports, 'LOCATION_REPLACE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_REPLACE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});
exports.routerMiddleware = routerMiddleware;

var _ConnectedRouter2 = require('./ConnectedRouter');

var _ConnectedRouter3 = _interopRequireDefault(_ConnectedRouter2);

var _reduxActions = require('redux-actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.ConnectedRouter = _ConnectedRouter3['default'];
var push = exports.push = (0, _reduxActions.createAction)(_reducer.LOCATION_CHANGE, function (path) {
  return {
    location: {
      pathname: path
    }
  };
});

var replace = exports.replace = (0, _reduxActions.createAction)(_reducer.LOCATION_REPLACE, function (path) {
  return {
    location: {
      pathname: path
    }
  };
});

var go = exports.go = (0, _reduxActions.createAction)(_reducer.LOCATION_GO, function (number) {
  return {
    step: number
  };
});

var goBack = exports.goBack = function goBack() {
  return go(-1);
};
var goForward = exports.goForward = function goForward() {
  return go(+1);
};

// based on https://github.com/reactjs/react-router-redux/blob/4.0.x/src/middleware.js
function routerMiddleware() {
  return function () {
    return function (next) {
      return function (action) {

        if (action.type === _reducer.LOCATION_GO) {
          window.history.go(action.payload.step);
        }

        if (action.type === _reducer.LOCATION_CHANGE) {
          var location = action.payload.location;


          if (location.pathname !== window.location.hash) {

            // HACK!!!
            // und ein sehr unschöner noch dazu..!!
            // leider im Moment nicht anders zu lösen...
            // Siehe:
            // https://github.com/ReactTraining/react-router/issues/4021
            // https://github.com/ReactTraining/react-router/issues/3972
            // https://github.com/ReactTraining/react-router/issues/4005
            // https://github.com/ReactTraining/react-history/issues/12

            window.location.hash = location.pathname;
          }
        }

        if (action.type === _reducer.LOCATION_REPLACE) {
          var _location = action.payload.location;


          if (_location.pathname !== window.location.hash) {

            // HACK!!!
            // und ein sehr unschöner noch dazu..!!
            // leider im Moment nicht anders zu lösen...
            // Siehe:
            // https://github.com/ReactTraining/react-router/issues/4021
            // https://github.com/ReactTraining/react-router/issues/3972
            // https://github.com/ReactTraining/react-router/issues/4005
            // https://github.com/ReactTraining/react-history/issues/12

            window.location.replace('#' + _location.pathname);
          }
        }

        return next(action);
      };
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ./program/frontend/components/react-router-redux/index.js
// module id = 773
// module chunks = 0